// extracted by mini-css-extract-plugin
module.exports = {"className":"textPromoTitleM_className__i5vJV"};